import {
  SEND_PDF_HISTORY_SEARCH,
  SEND_PDF_HISTORY_SEARCH_FAILURE,
  SEND_PDF_HISTORY_SEARCH_SUCCESS
} from './mutation-types'

export default {
  state: {
    pdfSendHistories: null,
    totalCount: null,
    pdf: null
  },
  getters: {
    pdfSendHistories: state => {
      return state.pdfSendHistories
    },
    totalCount: state => {
      return state.totalCount
    },
    historyPdf: state => {
      return state.pdf
    }
  },
  actions: {
    [SEND_PDF_HISTORY_SEARCH] ({ dispatch, state, commit }, params) {
      var url = '/pdf_send_history'
      var loadparams = true
      var data = {}
      var callback = () => {}

      if (params) {
        if (params.loadparams) {
          loadparams = params.loadparams
        }
        if (params.callback) {
          callback = params.callback
        }
        data = params.data
      }

      dispatch('apiGet', { url: url, data: data, loadparams: loadparams })
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(SEND_PDF_HISTORY_SEARCH_FAILURE, { data: res.data, callback: callback })
            } else {
              commit(SEND_PDF_HISTORY_SEARCH_SUCCESS, { data: res.data, callback: callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    }
  },
  mutations: {
    [SEND_PDF_HISTORY_SEARCH_FAILURE] (state, data) {
      console.log('REPORT_HISTORY_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [SEND_PDF_HISTORY_SEARCH_SUCCESS] (state, params) {
      console.log('REPORT_HISTORY_SEARCH_SUCCESS')
      var data = params.data
      state.pdfSendHistories = data
      state.totalCount = data.meta.totalcount
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/pdf-history.js